module.exports = __webpack_public_path__ + "img/6.0945aa59.png";